/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { Buttons, CustomInput } from 'components';
import { ArrowBack, DeleteIcon } from 'assets/icons';
import { getDayMonthYear } from 'utils';
import * as S from './CalendarFooter.styled';

export const CalendarFooter = ({
  footerStartDate$,
  footerEndDate$,
  handleClickOkBtn,
  handleClose,
}) => {
  const [startError, setStartError] = useState(isInvalidDate(footerStartDate$.value));
  const [endError, setEndError] = useState(isInvalidDate(footerEndDate$.value));

  useEffect(() => {
    setStartError(false);
    setEndError(false);
  }, [footerStartDate$.value, footerEndDate$.value]);

  function handleBlur(e) {
    if (!e.target.value) return;

    const isInvalidStart = isInvalidDate(footerStartDate$.value);
    const isInvalidEnd = isInvalidDate(footerEndDate$.value);

    if (isInvalidStart) setStartError(true);
    if (isInvalidEnd) setEndError(true);
    if (isInvalidStart || isInvalidEnd) return;

    // convert to a correct format if any 000
    footerStartDate$.value = footerStartDate$.value
      ? getDayMonthYear(new Date(footerStartDate$.value))
      : '';
    footerEndDate$.value = footerEndDate$.value
      ? getDayMonthYear(new Date(footerEndDate$.value))
      : '';
  }

  function handleButtonClick() {
    if (footerStartDate$.value && isInvalidDate(footerStartDate$.value)) {
      setStartError(true);
      return;
    } else if (footerEndDate$.value && isInvalidDate(footerEndDate$.value)) {
      setEndError(true);
      return;
    } else if (
      footerStartDate$.value &&
      footerEndDate$.value &&
      !isValidDateRange(footerStartDate$.value, footerEndDate$.value)
    ) {
      setEndError(true);
      setStartError(true);
    } else {
      handleClickOkBtn(null);
    }
  }

  return (
    <S.FoterContainer className='dateRangeFoter'>
      <CustomInput
        rightIcon={<DeleteIcon className='deleteIcon' />}
        rightIconOnClick={() => (footerStartDate$.value = '')}
        width={215}
        value={footerStartDate$.value}
        error={startError}
        name='footerStartDate'
        id='footerStartDate'
        onChange={(e) => (footerStartDate$.value = e.target.value)}
        onFocus={() => setStartError(false)}
        onBlur={handleBlur}
      />
      <S.ArrowWrap>
        <ArrowBack />
      </S.ArrowWrap>
      <CustomInput
        rightIcon={<DeleteIcon className='deleteIcon' />}
        rightIconOnClick={() => (footerEndDate$.value = '')}
        width={215}
        containerStyle={{ marginRight: '32px' }}
        value={footerEndDate$.value}
        error={endError}
        name='footerEndDate'
        id='footerEndDate'
        onChange={(e) => (footerEndDate$.value = e.target.value)}
        onFocus={() => setEndError(false)}
        onBlur={handleBlur}
      />
      <Buttons.SecondaryNormal
        id='cancel_calendar'
        onClick={handleClose}
        style={{ marginRight: '16px', marginLeft: 'auto' }}
      >
        Cancel
      </Buttons.SecondaryNormal>
      <Buttons.PrimaryNormal id='ok_calendar' onClick={handleButtonClick} style={{ width: '80px' }}>
        Ok
      </Buttons.PrimaryNormal>
    </S.FoterContainer>
  );
};

function isFutureDate(dateStr) {
  const [y, m, d] = dateStr.split('/').map(Number);
  return new Date(y, m - 1, d) > new Date().setHours(0, 0, 0, 0);
}

function isInvalidDate(dateStr) {
  if (!dateStr) return false;

  const parts = dateStr?.split('/')?.map(Number) || [];
  if (parts.length !== 3) return true;
  if (parts.some((value) => Number.isNaN(value))) return true;

  const [y, m, d] = parts;
  if (y < 2000 || m < 1 || m > 12 || d < 1 || d > 31) return true;

  const date = new Date(dateStr);
  if (date.toString() === 'Invalid Date') return true;
  if (date.getFullYear() !== y) return true;
  if (date.getMonth() + 1 !== m) return true;
  if (date.getDate() !== d) return true;

  return isFutureDate(dateStr);
}

function isValidDateRange(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return startDate <= endDate;
}
